import { Component } from "@angular/core";

@Component({
  selector: "app-plusmore-logo",
  standalone: true,
  imports: [],
  templateUrl: "./plusmore-logo.component.html",
  styleUrl: "./plusmore-logo.component.scss",
})
export class PlusmoreLogoComponent {
  logo: string = "logo/plusmore_logo.svg";
}
